import { createSlice }              from "@reduxjs/toolkit";

import { reportsApi }               from "src/store/services/reports";
import type { IGetReportsResponse } from "src/store/services/reports/interfaces/responses.interface";
import type { LazyListResponse }    from "src/store/services/utils/lazy-pagination";
import type { RootState }           from "src/store/store";
import { RequestStateEnum }         from "src/types";

type TReportsState = {
  byUser: { value: IGetReportsResponse[]; state: RequestStateEnum };
  all   : { value: LazyListResponse<IGetReportsResponse>; state: RequestStateEnum };
};

const initialState: TReportsState = {
  byUser: { value: [], state: RequestStateEnum.NODATA },
  all   : {
    value: {
      data   : [],
      total  : 0,
      limit  : 0,
      offset : 0,
      hasMore: false,
    },
    state: RequestStateEnum.NODATA,
  },
};

const slice = createSlice({
  name         : "reports",
  initialState,
  reducers     : {},
  extraReducers: (builder) => {
    builder.addMatcher(reportsApi.endpoints.getReports.matchPending,
      (state) => {
        state.all.state = RequestStateEnum.LOADING;
      });
    builder.addMatcher(reportsApi.endpoints.getReports.matchRejected,
      (state) => {
        state.all.state = RequestStateEnum.FAILED;
      });
    builder.addMatcher(reportsApi.endpoints.getReports.matchFulfilled,
      (state, { payload }) => {
        state.all.state = RequestStateEnum.FULLFILLED;
        state.all.value = payload;
      });
    builder.addMatcher(reportsApi.endpoints.getReportsByUser.matchPending,
      (state) => {
        state.byUser.state = RequestStateEnum.LOADING;
      });
    builder.addMatcher(reportsApi.endpoints.getReportsByUser.matchRejected,
      (state) => {
        state.byUser.state = RequestStateEnum.FAILED;
      });
    builder.addMatcher(reportsApi.endpoints.getReportsByUser.matchFulfilled,
      (state, { payload }) => {
        state.byUser.state = RequestStateEnum.FULLFILLED;
        state.byUser.value = payload;
      });
  },
});

export const selectReportsByUser = (state: RootState) =>
  state.reportsApi.byUser;

export const selectAllReports = (state: RootState) => state.reportsApi.all;

export const { reducer: reportsReducer } = slice;
